import feathers from '@feathersjs/client';
import { withResult } from 'feathers-fletching';
import { ContextCacheMap } from 'feathers-fletching';
import { cache, stashCache } from 'src/feathers/hooks';
import { scriptLoader } from 'straightline-ui';
import { parsePlace } from 'straightline-utils/validation';

const { GeneralError } = feathers.errors;

class Service {
  constructor(options) {
    this.options = options;
  }

  async get(id, params) {
    params = params || {};
    if (!this.placesService) {
      await scriptLoader.load(process.env.REACT_APP_GOOGLE_MAPS_URL);
      this.placesService = new window.google.maps.places.PlacesService(
        document.createElement('div')
      );
    }
    return new Promise((resolve, reject) => {
      this.placesService.getDetails(
        {
          placeId: id,
          language: 'en',
          fields: ['geometry', 'address_components', 'types', 'name'],
          ...params.query
        },
        (response, status) => {
          if (status !== 'OK') {
            reject(
              new GeneralError(
                'There was an error from Google getting place predictions.',
                { status }
              )
            );
          } else {
            resolve(parsePlace(response));
          }
        }
      );
    });
  }
}

const withResults = withResult({
  timezone: async (place, context) => {
    if (!context.app.auth) {
      return null;
    }
    const { timezone } = await context.app.service('api/addresses').find({
      query: {
        latitude: place.latitude,
        longitude: place.longitude
      }
    });
    return timezone;
  }
});

export default (app) => {
  const cacheMap = new ContextCacheMap({
    max: 50,
    ttl: 1000 * 60 * 60 * 24 * 7,
    ttlResolution: 1000 * 60 * 60 * 10,
    ttlAutopurge: true
  });

  app.storage
    .get('google/places')
    .then((cache) => {
      if (cache) {
        try {
          cacheMap.map.load(JSON.parse(cache));
        } catch (error) {}
      }
    })
    .catch((error) => {
      app.get('sentryClient').captureException(error, {
        method: 'get',
        path: 'storage:google/places'
      });
    });

  const options = { cacheMap };
  app.use('google/places', new Service(options));
  const service = app.service('google/places');

  service.hooks({
    before: {
      get: [cache]
    },
    after: {
      get: [withResults, cache, stashCache()]
    },
    error: {
      get: []
    }
  });
};
